import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

const PublicSellerMapMenu = ({ sellers, selectedSellerId, onSellerChange }) => {
  const sortedSellers = useMemo(() => {
    return [...sellers].sort((firstSeller, secondSeller) => {
      return `${firstSeller?.name ?? ''}`.localeCompare(`${secondSeller?.name ?? ''}`, 'fi');
    });
  }, [sellers]);

  return (
    <div className="fixed top-14 left-0 right-0 z-30 border-b border-slate-200/70 bg-white/94 px-3 py-2 text-slate-900 shadow-[0_12px_30px_rgba(15,23,42,0.1)] backdrop-blur md:px-6">
      <div className="flex w-full items-center gap-1.5 md:gap-2">
        <div className="shrink-0 leading-tight">
          <div className="hidden text-[10px] font-bold uppercase tracking-[0.26em] text-blue-700/80 md:block">Julkinen karttanäkymä</div>
          <div className="text-xs font-black text-slate-900 sm:text-sm md:text-base">Myyjät kartalla</div>
        </div>

        <div className="min-w-0 flex-1 md:mx-4 md:max-w-md">
          <label htmlFor="public-seller-select" className="sr-only">
            Valitse myyjä
          </label>

          <select
            id="public-seller-select"
            value={selectedSellerId}
            onChange={(event) => onSellerChange(event.target.value)}
            className="w-full min-w-0 rounded-xl border border-slate-300 bg-white px-2.5 py-1.5 text-xs font-medium text-slate-800 shadow-sm outline-none transition focus:border-blue-500 sm:text-sm"
          >
            <option value="all">Kaikki</option>
            {sortedSellers.map((seller) => (
              <option key={`${seller.companyID ?? seller.name}`} value={`${seller.companyID ?? seller.name}`}>
                {seller.name}
              </option>
            ))}
          </select>
        </div>

        <Link
          to="/myyjalista"
          className="ml-auto inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-xl border border-blue-200 bg-blue-50 px-2.5 py-1.5 text-xs font-bold text-blue-900 shadow-sm transition hover:border-blue-300 hover:bg-blue-100 sm:text-sm"
        >
          Myyjälista
        </Link>
      </div>
    </div>
  );
};

export default PublicSellerMapMenu;